export default "__VITE_ASSET__DyjVCOxU__"